module.exports = __webpack_public_path__ + "img/projeto_dog.4d0ba41e.gif";